Vue.component('sidebar', {
    template: `
        <div id="sideBar">

            <h4 @click="goToFamily" :class="{active: currentTab == 'familyInfo'}">{{ $language.famInfo }}</h4>

            <div class="pubList">
                {{ $language.pubList }}
                <ul class="noDecoration">
                    <li v-for="(member, index) in members" @click="goToMember(index)" :class="{active: currentTab == 'member' + index}">
                        <img class="img-fluid" :src="$setupPath + '../images/flags/png/' + member.c_country + '.png'" />
                        &nbsp;{{ member.c_publicationnumber + ' ' + member.c_kindcode }}
                    </li>
                </ul>

            </div>

            <hr />

            <div class="legalStatusLink">
                <ul class="noDecoration">
                    <li @click="goToFrame('priority')" :class="{active: currentTab == 'priority'}">
                        <img src="img/priorityMap.png" />&nbsp;Priority map
                    </li>
                    <li @click="goToFrame('table')" :class="{active: currentTab == 'table'}">
                        <img src="img/table.png" />&nbsp;Legal status - Table
                    </li>
                    <li @click="goToFrame('timeline')" :class="{active: currentTab == 'timeline'}">
                        <img src="img/timeline.png" />&nbsp;Legal status - Timeline
                    </li>
                    <li @click="goToFrame('reassignments')" :class="{active: currentTab == 'reassignments'}">
                        <img src="img/assignRight.png" />&nbsp;Reassignments
                    </li>
                </ul>

            </div>

            <hr />

            <div class="breakdown">
                {{ $language.breakPub }}:
                <ul>
                    <li @click="goToFrame('assignees')" :class="{active: currentTab == 'assignees'}">
                        {{ $language.assignees }}
                    </li>
                    <li @click="goToFrame('agents')" :class="{active: currentTab == 'agents'}">
                        {{ $language.agents }}
                    </li>
                    <li @click="goToFrame('inventors')" :class="{active: currentTab == 'inventors'}">
                        {{ $language.inventors }}
                    </li>
                    <li @click="goToFrame('examiners')" :class="{active: currentTab == 'examiners'}">
                        {{ $language.examiners }}
                    </li>
                </ul>

            </div>

        </div>
    `,
    data: function() {
        return {
            currentTab: 'familyInfo'
        };
    },

    computed: {
        members() {
            return this.$store.getters.membersData;
        }
    },

    methods: {
        goToMember(index) {
            this.currentTab = 'member' + index;
            this.$store.commit('GO_TO_MEMBER', index);
        },

        goToFamily() {
            this.currentTab = 'familyInfo';
            this.$store.commit('GO_TO_FAMILY');
        },

        goToFrame(target) {
            this.currentTab = target;
            EventBus.$emit('SHOW_LOADING', true);
            this.$store.commit('GO_TO_FRAME', target);
        }
    }
});
